import { Link, useParams } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../router/all_routes";
import { useEffect, useMemo, useRef, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import useApi from "../../../core/customhook/useApi";
import Swal from "sweetalert2";
import CommonTagsInputWithSuggestions from "../../../core/common/Taginput/index copy";
import { DatePicker } from "antd";
import JoditEditor from "jodit-react";

interface Employee {
    employee_id: string;
    employee_name: string;
    department: string;
}

const EditTask = () => {

    const [attachments, setAttachments] = useState<File[]>([]);
    const [teamMembers, setTeamMembers] = useState<Employee[]>([]);
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [projectData, setProjectData] = useState([])
    const [content, setContent] = useState("");
    const [proName, setProName] = useState("");
    const [count, setCount] = useState(1)
    const [isDuration, setIsDuration] = useState(false);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [teamMemberData, setTeamMemberData] = useState([])
    const [filteredSuggestions, setFilteredSuggestions] = useState<any[]>([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const editor = useRef(null);
    const [tags, setTags] = useState<string[]>([]);
    const [data, setData] = useState({
        task_id: "",
        project_id: "",
        project_name: "",
        task_name: "",
        duration: "",
        work_hour: "",
        billing_type: "",
        priority: "",
        complete: 0,
        status: "Pending"
    });

    const { taskId } = useParams<{ taskId: string }>()

    const { callApi: editProjectTask } = useApi("/api/update-project-task", {
        method: "POST",
        autoCall: false,
    });

    const config = useMemo(
        () => ({
            readonly: false,
        }),
        []
    );

    const getInputData = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const handleChangeStatus = () => {
        setIsDuration(!isDuration);
    };

    const {
        data: taskData,
        loading: taskLoading,
        error: taskError,
    } = useApi("/api/get-all-project-task", {
        method: "GET",
        autoCall: true,
        dependencies: [count]
    });


    console.log("Api Response :", taskData)
    useEffect(() => {
        if (!taskData || !taskId) return;

        const record = taskData?.data.find(
            (p: any) => p.task_id === Number(taskId)
        );

        if (!data) return;

        setData({
            project_name: record.project_name,
            project_id: record.project_id,
            task_name: record.task_name,
            duration: record.duration,
            work_hour: record.work_hour,
            billing_type: record.billing_type,
            priority: record.priority,
            task_id: record.task_id,
            complete: record.complete || 0,
            status: record.status || "Pending"
        })
        setContent(record.description)
        setTeamMembers(record.team_members)
        setTags(record.tags)
        setStartDate(record.start_date ? dayjs(record.start_date) : null);
        setEndDate(record.end_date ? dayjs(record.end_date) : null);

    }, [taskData?.data, taskId]);


    const editProjectTaskData = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("task_id", data.task_id);
        formData.append("project_id", data.project_id);
        formData.append("task_name", data.task_name);
        formData.append("priority", data.priority);
        formData.append("billing_type", data.billing_type || "");
        formData.append("work_hour", data.work_hour || "");
        formData.append("complete", data.complete.toString())
        formData.append("status", data.status || "Pending");

        if (data.duration) {
            formData.append("duration", data.duration);
        }

        if (startDate) {
            formData.append("start_date", startDate.format("YYYY-MM-DD"));
        }

        if (endDate) {
            formData.append("due_date", endDate.format("YYYY-MM-DD"));
        }

        formData.append("description", content);

        tags.forEach((tag) => {
            formData.append("tags[]", tag);
        });

        teamMembers.forEach((member) => {
            formData.append("team_members[]", member.employee_id);
        });

        attachments.forEach((file) => {
            formData.append("file_path", file);
        });

        try {
            const response = await editProjectTask(formData);
            if (response.success) {
                Swal.fire({
                    title: "Updated!",
                    text: "Project task updated successfully.",
                    icon: "success",
                    confirmButtonText: "OK"
                });
                document.getElementById("close_modal_edit")?.click();
                setCount(count + 1);
            }
        } catch (error) {
            console.error("Edit failed:", error);
        }
    };


    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Tasks</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to={all_routes.employeeDashboard}>
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item">Employee</li>
                                <li className="breadcrumb-item active">Tasks</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="my-xl-auto right-content d-flex">
                        <div className="mb-2">
                            {/* <Link
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#add_task"
                                className="btn btn-primary d-flex align-items-center"
                            >
                                <i className="ti ti-circle-plus me-2" />
                                Add Task
                            </Link> */}
                        </div>
                        <div className="head-icons ms-2 mb-0">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>
                {/* Breadcrumb */}
                <div className="container-fluid">

                    {/* Page Header */}
                    <div className="row mb-4">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">Edit Task</h4>
                            <button
                                type="button"
                                className="btn btn-light"
                                onClick={() => window.history.back()}
                            >
                                <i className="ti ti-arrow-left me-1" />
                                Back
                            </button>
                        </div>
                    </div>

                    {/* Card */}
                    <div className="card">
                        <form onSubmit={editProjectTaskData}>
                            <div className="card-body">

                                <div className="row">

                                    {/* Project Name */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Project Name<sup className="text-danger">*</sup>
                                            </label>

                                            <div style={{ position: "relative" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={data.project_name}
                                                    placeholder="Project Name"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setData({ ...data, project_name: value });

                                                        if (value.trim()) {
                                                            const matches = projectData.filter((item: any) =>
                                                                item.project_name
                                                                    .toLowerCase()
                                                                    .includes(value.toLowerCase())
                                                            );
                                                            setFilteredSuggestions(matches);
                                                            setShowSuggestions(true);
                                                        } else {
                                                            setFilteredSuggestions([]);
                                                            setShowSuggestions(false);
                                                        }
                                                    }}
                                                />

                                                {showSuggestions && filteredSuggestions.length > 0 && (
                                                    <div
                                                        className="dropdown-menu show"
                                                        style={{
                                                            width: "100%",
                                                            maxHeight: "350px",
                                                            overflowY: "auto",
                                                            position: "absolute",
                                                            zIndex: 1000,
                                                        }}
                                                    >
                                                        <table className="table table-bordered table-hover mb-0">
                                                            <thead className="table-light sticky-top">
                                                                <tr>
                                                                    <th>Project Name</th>
                                                                    <th>Cost Center Code</th>
                                                                    <th>Department</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {filteredSuggestions.map((item, index) => (
                                                                    <tr
                                                                        key={index}
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => {
                                                                            setData({
                                                                                ...data,
                                                                                project_name: item.project_name,
                                                                            });
                                                                            setShowSuggestions(false);
                                                                        }}
                                                                    >
                                                                        <td>{item.project_name}</td>
                                                                        <td>{item.cost_center_code}</td>
                                                                        <td>{item.department_name}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Task Name */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Task Name<sup className="text-danger">*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="task_name"
                                                value={data.task_name}
                                                onChange={getInputData}
                                            />
                                        </div>
                                    </div>

                                    {/* Team Members */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Team Members<sup className="text-danger">*</sup>
                                            </label>
                                            <CommonTagsInputWithSuggestions
                                                value={teamMembers}
                                                onChange={setTeamMembers}
                                                suggestions={teamMemberData}
                                                placeholder="Team Members"
                                            />
                                        </div>
                                    </div>

                                    {/* Start Date */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Start Date<sup className="text-danger">*</sup>
                                            </label>
                                            <DatePicker
                                                className="form-control"
                                                value={startDate}
                                                format={{ format: "DD-MM-YYYY", type: "mask" }}
                                                onChange={(date) => setStartDate(date)}
                                                disabledDate={(current) =>
                                                    current && current.isBefore(dayjs().startOf("day"))
                                                }
                                            />
                                        </div>
                                    </div>

                                    {/* Due Date / Duration */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between">
                                                <label className="form-label">
                                                    {isDuration ? "Duration" : "Due Date"}
                                                </label>
                                                <span
                                                    onClick={handleChangeStatus}
                                                    style={{
                                                        color: "blue",
                                                        cursor: "pointer",
                                                        textDecoration: "underline",
                                                    }}
                                                >
                                                    {isDuration ? "Enter End Date" : "Enter Duration"}
                                                </span>
                                            </div>

                                            {isDuration ? (
                                                <div className="d-flex">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="duration"
                                                        value={data.duration}
                                                        onChange={getInputData}
                                                    />
                                                    <select className="form-control ms-2" style={{ maxWidth: 100 }}>
                                                        <option>days</option>
                                                        <option>hrs</option>
                                                    </select>
                                                </div>
                                            ) : (
                                                <DatePicker
                                                    className="form-control"
                                                    value={endDate}
                                                    format={{ format: "DD-MM-YYYY", type: "mask" }}
                                                    onChange={(date) => setEndDate(date)}
                                                    disabledDate={(current: any) =>
                                                        current &&
                                                        (current.isBefore(dayjs().startOf("day")) ||
                                                            (startDate && current.isBefore(startDate)))
                                                    }
                                                />
                                            )}
                                        </div>
                                    </div>

                                    {/* Work Hours */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Work Hours<sup className="text-danger">*</sup>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="work_hour"
                                                value={data.work_hour}
                                                onChange={getInputData}
                                            />
                                        </div>
                                    </div>

                                    {/* Description */}
                                    <div className="col-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Description<sup className="text-danger">*</sup>
                                            </label>
                                            <JoditEditor
                                                ref={editor}
                                                value={content}
                                                config={config}
                                                onBlur={(newContent) => setContent(newContent)}
                                            />
                                        </div>
                                    </div>

                                    {/* Completion */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Completion (%)<sup className="text-danger">*</sup>
                                            </label>
                                            <select
                                                className="form-select"
                                                value={data.complete}
                                                onChange={(e) =>
                                                    setData({ ...data, complete: Number(e.target.value) })
                                                }
                                            >
                                                {[...Array(11)].map((_, i) => (
                                                    <option key={i} value={i * 10}>
                                                        {i * 10}%
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {/* Status */}
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Status<sup className="text-danger">*</sup>
                                            </label>
                                            <select
                                                className="form-select"
                                                value={data.status}
                                                onChange={(e) =>
                                                    setData({ ...data, status: e.target.value })
                                                }
                                            >
                                                <option value="Pending">Pending</option>
                                                <option value="Ongoing">Ongoing</option>
                                                <option value="Complete">Completed</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* Footer */}
                            <div className="card-footer text-end">
                                <button
                                    type="button"
                                    className="btn btn-light me-2"
                                    onClick={() => window.history.back()}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className="btn btn-primary">
                                    Edit Task
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default EditTask;